import { render, staticRenderFns } from "./upload-instructions.vue?vue&type=template&id=18c265d3&scoped=true"
import script from "./upload-instructions.vue?vue&type=script&lang=js"
export * from "./upload-instructions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c265d3",
  null
  
)

export default component.exports